module.exports = __webpack_public_path__ + "static/ula-6529bf910bbcf7c64723d36194c11c14.png";